var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAttachmentOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22c-1.533 0-2.833-.533-3.9-1.6C7.533 19.333 7 18.033 7 16.5V6c0-1.1.392-2.042 1.175-2.825C8.958 2.392 9.9 2 11 2s2.042.392 2.825 1.175C14.608 3.958 15 4.9 15 6v9.5c0 .7-.242 1.292-.725 1.775-.483.483-1.075.725-1.775.725s-1.292-.242-1.775-.725C10.242 16.792 10 16.2 10 15.5V6h1.5v9.5c0 .283.096.52.288.712a.965.965 0 00.712.288.968.968 0 00.713-.288.967.967 0 00.287-.712V6c0-.7-.242-1.292-.725-1.775C12.292 3.742 11.7 3.5 11 3.5s-1.292.242-1.775.725C8.742 4.708 8.5 5.3 8.5 6v10.5c0 1.1.392 2.042 1.175 2.825.783.783 1.725 1.175 2.825 1.175s2.042-.392 2.825-1.175c.783-.783 1.175-1.725 1.175-2.825V6H18v10.5c0 1.533-.533 2.833-1.6 3.9-1.067 1.067-2.367 1.6-3.9 1.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachmentOutline);
export default __webpack_public_path__ + "6c3c3f96ce4fd15f66f8774352aeaa45.svg";
export { ForwardRef as ReactComponent };